import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import * as Styled from './styled';
import Breadcrumbs from '../Breadcrumbs';
import { ReactComponent as Scroll } from '../../assets/svgs/scroll.svg'
import { ReactComponent as ScrollBlue } from '../../assets/svgs/scroll-blue.svg'
import scrollToPlansSection from '../../shared/helpers/scrollToPlansSection'

const Banner = ({
  breadcrumbs,
  children,
  title,
  image,
  imgStyle,
  imgWrapperStyle,
  alt,
  backgroundImage,
  wrapperStyle,
  contentStyle,
  hasKnowMore,
  isBlueKnowMore,
  observation,
}) => {
  const [Wrapper, wrapperProps] = backgroundImage ?
    [Styled.WrapperWithBackground, { Tag: 'header', fluid: backgroundImage }]
    : [Styled.Wrapper, {}];

  return (
    <>
      <Wrapper style={wrapperStyle} {...wrapperProps} data-qa="banner">
        <Styled.ContentWrapper style={contentStyle}>
          {breadcrumbs.length > 0 &&
            <Breadcrumbs items={breadcrumbs} />
          }
          <Styled.Title variant="h1" gutterBottom>
            {title}
          </Styled.Title>
          {children}
        </Styled.ContentWrapper>
        {image && <Styled.ImageWrapper style={imgWrapperStyle}>
          <Img
            fluid={image}
            alt={alt}
            imgStyle={{ objectFit: 'cover', objectPosition: '0 100%', width: '100%', height: '100%', ...imgStyle }}
          />
        </Styled.ImageWrapper>}
        {hasKnowMore && <Styled.KnowMore onClick={scrollToPlansSection}>
          {isBlueKnowMore ? <ScrollBlue /> : <Scroll />}
          <strong style={isBlueKnowMore ? { color: '#111A3C' } : {}}>Saiba mais</strong>
        </Styled.KnowMore>}
      </Wrapper>
      {observation && <Styled.Observation>{observation}</Styled.Observation>}
    </>
  );
}

Banner.propTypes = {
  alt: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired
  })),
  children: PropTypes.node,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
  image: PropTypes.objectOf(PropTypes.any),
  imgStyle: PropTypes.any,
  contentStyle: PropTypes.any,
  imgWrapperStyle: PropTypes.any,
  backgroundImage: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  backgroundStyle: PropTypes.any,
  wrapperStyle: PropTypes.any,
  observation: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
};

Banner.defaultProps = {
  alt: 'Imagem do banner',
  breadcrumbs: [],
  backgroundStyle: {},
  imgStyle: {},
  contentStyle: {},
  imgWrapperStyle: {},
  wrapperStyle: {},
  hasKnowMore: false,
  observation: '',
}

export default memo(Banner); 
